import React from 'react'

import facebook from '../img/facebook.svg'
import twitter from '../img/twitter.svg'

import Link from "gatsby-link"

export default class Footer extends React.Component {

	render() {
		return (

		<div className="footer">
			<div className="container">
				<div className="footer-list-container">
					<ul className="footer-list footer-list-terms">
						<li><Link to="/privacy_policy.html" title="Privacy Policy">Privacy Policy</Link></li>
						<li><Link to="/cookie_policy.html" title="Cookie Policy">Cookie Policy</Link></li>
						<li><Link to="/terms_of_use.html" title="Terms of Use">Terms of Use</Link></li>
						<li><a href="/pdf/simba_terms_of_service.pdf" title="Simba Terms of Service and Refunds Policy">Simba Terms of Service and Refunds Policy</a></li>
					</ul>
					<ul className="footer-list">
						<li><Link to="/make_money_writing.html" title="Make money writing">Make money writing</Link></li>
						<li><Link to="/get_paid_to_write.html" title="Get paid to write">Get paid to write</Link></li>

						<li><Link to="/freelance_writing_jobs.html" title="Freelance writing jobs">Freelance writing jobs</Link></li>
						<li><Link to="/work_from_home_online.html" title="Work from home online">Work from home online</Link></li>

						<li><Link to="/writing_jobs_from_home.html" title="Writing jobs from home">Writing jobs from home</Link></li>
						<li><Link to="/jobs_for_writers.html" title="Jobs for writers">Jobs for writers</Link></li>

						<li><Link to="/writing_for_money.html" title="Writing for money">Writing for money</Link></li>
						<li><Link to="/part_time_jobs.html" title="Part time jobs">Part time jobs</Link></li>

						<li><Link to="/online_writing_jobs.html" title="Online writing jobs">Online writing jobs</Link></li>
						<li><a href="https://www.uvocorp.com/freelancewriting/sitemap" title="Sitemap">Sitemap</a></li>

						<li><a href="https://www.uvocorp.com/freelancewriting/investing-in-others/" className="footer-link-investing" title="Investing in others" target="_blank">&hearts; Investing in others</a></li>
					</ul>
					<ul className="footer-list footer-list-country">
						<li><a href="https://europe.uvocorp.com/" title="Europe">Europe</a></li>
						<li><a href="https://canada.uvocorp.com/" title="Canada">Canada</a></li>
						<li><a href="https://nigeria.uvocorp.com/" title="Nigeria">Nigeria</a></li>
						<li><a href="https://hongkong.uvocorp.com/" title="Hongkong">Hong Kong</a></li>
						<li><a href="https://pakistan.uvocorp.com/" title="Pakistan">Pakistan</a></li>
						<li><a href="https://india.uvocorp.com/" title="India">India</a></li>
						<li><a href="https://philippines.uvocorp.com/" title="Philippines">Philippines</a></li>
					</ul>
				</div>
				<div className="footer-bottom">
					<p className="footer-copyright">© 2008 - {new Date().getFullYear()} UvoCorp.com. Writera Limited, Limassol, Cyprus. All rights reserved.</p>
					<ul className="footer-social">
						<li className="footer-social-truste">
							<a href="//privacy.truste.com/privacy-seal/validation?rid=91021013-5f4c-4d13-8123-c5d380903cb6" target="_blank">
								<img src="//privacy-policy.truste.com/privacy-seal/seal?rid=91021013-5f4c-4d13-8123-c5d380903cb6" alt="TRUSTe" />
							</a>
						</li>
						<li>
							<a href="https://www.facebook.com/UvoCorp/" rel="nofollow" title="Facebook" target="_blank"><img src={facebook} alt="Facebook"/></a>
						</li>
						<li>
							<a href="https://twitter.com/UvoCorp" rel="nofollow" title="Twitter" target="_blank"><img src={twitter} alt="Twitter"/></a>
						</li>
					</ul>

				</div>

			</div>
		</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/layouts/footer.js